export default "<div class=\"item\">\n    {{item | json}}\n</div>";